import { QueryClient } from '@tanstack/react-query';

/**
 * Единственный QueryClient приложения.
 *
 * Вынесен из `App.tsx` в отдельный модуль, чтобы к тому же кэшу мог обращаться
 * код ВНЕ React-дерева — эффекты карты, контексты и хелперы, которые дергают
 * API императивно (`queryClient.fetchQuery`). До этого такой код ходил мимо
 * react-query голым `fetch`, и одинаковые GET'ы летели десятками за сессию
 * (перф-аудит карты 14.08, корень 6).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
